import React from "react";
import "./Surrounding.scss";
import aeon from "../../../Media/Surrounding_alsut/AEON Mall.webp";
import prasmul from "../../../Media/Surrounding_alsut/Binus University.webp";
import binus from "../../../Media/Surrounding_alsut/Alam Sutera Mall.webp";
import breeze from "../../../Media/Surrounding_alsut/Brawijaya Hospital.webp";
import qbig from "../../../Media/Surrounding_alsut/Soekarno-Hatta Airport.webp";
import eka from "../../../Media/Surrounding_alsut/Toll Gate Pinang.webp";
import tol from "../../../Media/Surrounding_alsut/Kunciran MRT Station.webp";
import sekolah from "../../../Media/Surrounding_alsut/IKEA.webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Surrounding = () => {
  const slides = [
    {src: aeon, des: "AEON Mall"},
    {src: prasmul, des: "Binus University"},
    {src: binus, des: "Alam Sutera Mall"},
    {src: breeze, des: "Brawijaya Hospital"},
    {src: qbig, des: "Soekarno-Hatta Airport"},
    {src: eka, des: "Toll Gate Pinang"},
    {src: tol, des: "Kunciran MRT Station"},
    {src: sekolah, des: "IKEA"},
  ];
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    lazyLoad: true,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div id="surrounding" className="surroundingcontainer">
      <div className="title">Surrounding Area</div>
      <div className="content">
        {slides.map((slide, index) => (
          <div className="center" key={index}>
            <img className="imgcontent" src={slide.src} alt="Surrounding" />
            <div className="imgdes">
              <span>{slide.des}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="content1">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div className="center" key={index}>
              <img className="imgcontent" src={slide.src} alt="Surrounding" />
              <div className="imgdes">
                <span>{slide.des}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Surrounding;
